import styled, {keyframes} from "styled-components"

export const Background = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: #cbb9d9;
`
export const Header1 = styled.h1`
    font-family: 'Kinkee';
    font-size: 4rem;
    color: #794b9c;
    align-self: center;
    @media (max-width: 767px) {
        font-size: 2.0rem;
    }
`

export const Paragraph = styled.p`
    text-align:center;
    align-self: center;
    max-width: 50%;
    font-family: 'KiwiSoda';
    font-size: 2rem;
    color: #420942;
     @media (max-width: 767px) {
        max-width: 80%;
        font-size: 1.75rem;
    }
`
export const PData = styled.p`
    bottom: 0px;
    font-family: 'KiwiSoda';
    display: block;
    color: #420942;

`

export const ProjDeets = styled.div`
    align-self: center;
    border-bottom: 0px;
    text-align: center;
    font-size: 2rem;
     @media (max-width: 767px) {
        max-width: 80%;
        font-size: 1.75rem;
    }
    
`

export const GalleryContainer = styled.div`
    align-self: center;
    padding: 20px;
    background-color: rgba(121, 75, 156, 0.5);
    border-radius: 20%;
    display:flex;
    @media (max-width: 767px) {
        max-width: 80%;
    }
`

export const ArrowAnim = keyframes`
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(1.2);
    }
`
export const ReverseArrowAnim = keyframes`
    0%{
        transform: scale(1.2);
    }
    100%{
        transform: scale(1);
    }
`
export const ClickArrowAnim = keyframes`
    0%{
        transform: scale(1.2);
    }
    100%{
        transform: scale(1);
    }

`

export const GalleryImages = styled.img`
    max-width: 800px;
    border-radius: 10%;
      @media (max-width: 767px) {
        max-width: 65%;
    }
`
export const GalleryArrow = styled.img`
    max-width: 50px;
    position: relative;
    align-self: center;   
    padding-left: ${(props) => (props.left ? '0px' : '20px')};
    padding-right: ${(props) => (props.right ? '0px' : '20px')};
    animation-name: ${ReverseArrowAnim};
    animation-duration: 500ms;
    animation-fill-mode: forwards;

    &:hover{
        animation-name: ${ArrowAnim};
        animation-duration: 100ms;
        animation-fill-mode: forwards;
    }

    &:active{
        animation-name: ${ClickArrowAnim};
        animation-duration: 50ms;
    }
    
    
`
export const Gradient = styled.div`
    background: linear-gradient(#f1a9ca, #cbb9d9);
    min-height: 100px;
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 200px;
`

export const Vid = styled.video`
    max-width: 800px;
    align-self: center;
    border-radius: 20px;
    @media (max-width: 767px) {
        max-width: 90%;
    }

`
export const Alinks = styled.a`

`